import { useState } from 'react';


const NumberSort = () => {
  const [numbers, setNumbers] = useState('');
  const [sortedNumbers, setSortedNumbers] = useState('');
  const [sortOrder, setSortOrder] = useState('asc');


  const handleSort = () => {
    const numArray = numbers.split(',').map(Number);
    const sortedArray = sortOrder === 'asc' ? numArray.sort((a, b) => a - b) : numArray.sort((a, b) => b - a);
    setSortedNumbers(sortedArray.join(','));
  };

  const [copyButtonLabel, setCopyButtonLabel] = useState('Copy Text'); // State for button label


  const handleCopy = () => {
    navigator.clipboard.writeText(sortedNumbers);
    setCopyButtonLabel('Copied!'); // Update button label to "Copied!"
    setTimeout(() => setCopyButtonLabel('Copy Text'), 1500); // Revert back to "Copy Number" after 1.5 seconds
  };


  // Clear input fields
  const clearFields = () => {
    setNumbers('');
    setSortedNumbers('');
    setSortOrder('');
  };


  const handleSortOrder = () => {
    setSortOrder(sortOrder === 'asc' ? 'desc' : 'asc');
  };


   // Function to calculate text statistics
   const calculateTextStats = (text) => {
    const totalCharacters = text.length;
    const totalCharactersWithoutSpace = text.replace(/\s+/g, '').length;
    const totalWords = text.trim() === '' ? 0 : text.trim().split(/\s+/).length;
    const totalParagraphs = text.split(/\n+/).filter(Boolean).length;
    const totalSentences = text.split(/[.!?]+/).filter(Boolean).length;

    return {
      totalCharacters,
      totalCharactersWithoutSpace,
      totalWords,
      totalParagraphs,
      totalSentences,
    };
  };


    // Calculate stats dynamically based on current binary value
const stats = calculateTextStats(numbers);


  return (
    <div className="container mt-5 p-4 bg-white rounded shadow">
    <div className="card-body">
      <h1 className="card-title text-center">Number Sorter</h1>
      <textarea
        className="form-control mb-3"
        value={numbers}
        onChange={(e) => setNumbers(e.target.value)}
        placeholder= "Enter numbers separated by commas"
      />
      <div className="d-flex justify-content-between mb-3">
        <button
          className="btn btn-primary"
          onClick={handleSort}
        >
        Sort
        </button>
        <button
          className="btn btn-secondary"
          onClick={handleSortOrder}
        >
          {sortOrder === 'asc' ? 'Sort Desc' : 'Sort Asc'}
        </button>
      </div>
      <textarea
        className="form-control mb-3"
        value={sortedNumbers}
        readOnly
      />
      <button
        className="btn btn-success w-100"
        onClick={handleCopy}
      >
     {copyButtonLabel}
     </button>

      <button className="btn btn-danger mt-3" onClick={clearFields}>
            Clear
          </button>
    </div>

  <div className="mt-3 text-muted">
            <p>
              Total Characters with Space: {stats.totalCharacters} | Total Characters without Space: {stats.totalCharactersWithoutSpace} | Total Words: {stats.totalWords}</p>
            <p>
               Total Paragraphs: {stats.totalParagraphs} | Total Sentences: {stats.totalSentences}
            </p>
          </div>
</div>

  );
};

export default NumberSort;